import { Component, OnInit } from '@angular/core';
import { CanvasOptionsService } from 'src/app/service/canvas-options.service';
import { Subscription } from 'rxjs';
import { UndoService } from 'src/app/service/undo.service';
import { CanvasStateService } from 'src/app/service/canvas-state.service';

@Component({
  selector: 'app-layer-control',
  templateUrl: './layer-control.component.html',
  styleUrls: ['./layer-control.component.less']
})
export class LayerControlComponent implements OnInit {
  subscription: Subscription;
  removeActive:boolean;

  constructor(
    public canvasOptionsService: CanvasOptionsService,
    public undoService:UndoService,
    public canvasState: CanvasStateService,
    ) { }

  ngOnInit() {
    this.subscription = this.canvasState.canvasState$.subscribe(data => {  

      if(data.staticName=='remove')
        this.removeActive=data.active;
      else
        this.removeActive=false
    });
  }

  
  undo(){
    let action=this.undoService.undo();
  }

  remove(){
    // let action=this.canvasOptionsService.getActiveZone()
    // this.canvasOptionsService.setActiveZone('REMOVE-CONTOUR',action.id)
    let state=this.canvasState.canvasState;
    if(state.staticName=='remove' && state.active==true){
      this.canvasState.setState('remove',false)
    }else{
      this.canvasState.setState('remove',true)
    }
  }
  

}
